import styled from 'styled-components';
import {LIGHT_BLUE4, mobileMedia} from '../../globalVariables/GlobalVariables';
import {dFlexColumn, alignCenter, justifyCenter, flexRow} from '../../globalVariables/GlobalFlex';

const baseCardText = `
    text-align: center;
    line-height: 122%;
`;

export const card = styled.div`
    border-radius: 10px;
    border: 3px solid ${LIGHT_BLUE4};
    background: rgba(142, 237, 255, 0.08);
    padding-inline: 10px;
    padding-block: 20px;
    ${dFlexColumn}
    gap: 10px;
    min-width: 190px;
`;

export const cardSection = styled.div`
    ${dFlexColumn}
    height: calc(100% - 40px);
`;

export const cardMainSection = styled(cardSection)`
    ${alignCenter}
    padding: 8px 0;
    border-top: 1px solid ${LIGHT_BLUE4};
    border-bottom: 1px solid ${LIGHT_BLUE4};
    width: 100%;
    height: max-content;
    ${flexRow}
    ${justifyCenter}
    ${mobileMedia} {
        gap: 12px;
    }
`;

export const cardBottomSection = styled(cardSection)`
`;

export const cardTitle = styled.div`
    ${baseCardText}
    font-size: 16px;
    font-weight: 800;
    letter-spacing: -0.16px;
    margin-bottom: 2px;
`;

export const cardSubtitle = styled.div`
    ${baseCardText}
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.6px;
`;

export const cardNumber = styled.div`
    ${baseCardText}
    font-size: 32px;
    font-weight: 700;
    line-height: 90%;
    letter-spacing: -0.32px;
    margin-bottom: 4px;
`;

export const cardBoldText = styled.div`
    ${baseCardText}
    font-size: 12px;
    font-weight: 700;
`;

export const cardRegularText = styled.div`
    ${baseCardText}
    text-align: center;
    font-size: 12px;
    font-weight: 300;
    white-space: pre-line;
`;

export const cardSmallTitle = styled.div`
    ${baseCardText}
    text-align: start;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: -0.1px;
`;

export const cardNote = styled.div`
    ${baseCardText}
    text-align: start;
    font-size: 10px;
    font-weight: 400;
    letter-spacing: -0.1px;
`;

export const dataSection = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    height: 80px;
    flex: 1;
`; 